import {
  LOAD_VEHICLE_BLACKLIST,
  CREATE_VEHICLE_BLACKLIST,
  LOAD_VEHICLE_BLACKLIST_DETAIL,
  UPDATE_VEHICLE_BLACKLIST,
  EXPORT_VEHICLE_BLACKLIST,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  Lists: [],
  EditList: [],
  total: 1,
  loading: false,
  draw: -1,
  check: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_VEHICLE_BLACKLIST.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_VEHICLE_BLACKLIST.SUCCESS:
      const { page, pageSize } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * pageSize
      }
      return {
        ...state,
        Lists: action.payload.lists.data,
        total:
          action.payload.lists.data.length - 1 <= 0
            ? 1
            : action.payload.lists.data.length <= 0
            ? 1
            : action.payload.lists.data.length,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case CREATE_VEHICLE_BLACKLIST.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case CREATE_VEHICLE_BLACKLIST.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_VEHICLE_BLACKLIST_DETAIL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_VEHICLE_BLACKLIST_DETAIL.SUCCESS:
      return {
        ...state,
        EditList: action.payload.lists,
        loading: false,
        check: false,
      }

    case UPDATE_VEHICLE_BLACKLIST.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_VEHICLE_BLACKLIST.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case EXPORT_VEHICLE_BLACKLIST.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case EXPORT_VEHICLE_BLACKLIST.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
